import { Collection } from "@tblabs/truffle";
import { Song } from "./Song";


export interface RawPlaylist
{
    Id: string;
    Name: string;
    SongsIds: string[];
}

export class Playlist
{
    public Id: string;
    public Name: string;
    public Songs = new Collection<Song>();

    constructor(id?: string, name?: string, songs?: Song[])
    {
        this.Id = id ?? "";
        this.Name = name ?? "";
        this.Songs.Load(...(songs ?? []));
    }

    public ToRaw(): RawPlaylist
    {
        return {
            Id: this.Id,
            Name: this.Name,
            SongsIds: this.Songs.Items.map(song => song.Id)
        };
    }

    public static get Default(): Playlist
    {
        return new Playlist("default", "Default", []);
    }
}
